/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Table, Button } from "reactstrap";
import { FormattedNumber } from "react-intl";
import style from "./Bulk.module.scss";
import Edit from "./Edit";
import { IOType, IOMode } from "../../../../IO/types";
import { updateAccountBanks } from "../Default";

const Assets = ({ error, itemsHeader, items, isCurrency, ioType, ioMode, readonly, dispatch, ...props }) => {
  const [edit, setEdit] = useState({
    open: false,
    item: { IsCurrency: isCurrency },
  });

  const toggleEdit = (item = { IsCurrency: isCurrency }) => {
    setEdit({
      open: !edit.open,
      item,
    });
  };

  const onEdit = (item) => {
    dispatch({ type: "EDIT_BULK_ITEM", item });
  };

  const onDelete = (itemId) => {
    dispatch({ type: "DELETE_BULK_ITEM", itemId });
  };

  if (edit.open) {
    return (
      <React.Fragment>
        <Edit
          toggle={toggleEdit}
          ioType={ioType}
          accountId={props.accountId}
          ioMode={ioMode}
          local={props.local}
          entities={props.entities}
          item={edit.item}
          edit={onEdit}
          services={props.services}
        />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div>
        <React.Fragment>
          <Button
            color="primary"
            className={`${style.btnAdd} ${style[ioType]} btn-sm`}
            onClick={() => toggleEdit()}
            disabled={readonly}
          >
            <i className="fa fa-plus" />
            {"\u00A0"} Add {isCurrency ? "Currency" : "Asset"}
          </Button>
          <div className={`${style.table} ${error ? style.error : ""}`}>
            <Table responsive striped>
              <thead>
                <tr>
                  <th>Quantity</th>
                  <th>{isCurrency ? "Currency" : "Asset"}</th>
                  {ioType == IOType.Withdraw && ioMode == IOMode.MultipleAccounts && <th>Bank Account</th>}
                  <th />
                </tr>
              </thead>
              <tbody>
                {items.map((i, ind) => (
                  <Item
                    key={`r-${i.Id}-${ind}`}
                    item={i}
                    ioType={ioType}
                    ioMode={ioMode}
                    local={props.Local}
                    onDelete={() => onDelete(i.Id)}
                    toggleEdit={() => toggleEdit(i)}
                    readonly={readonly}
                  />
                ))}
              </tbody>
            </Table>
          </div>
          {error && (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {error}
            </div>
          )}
        </React.Fragment>
      </div>
    </React.Fragment>
  );
};

const Item = ({ item, readonly, ioType, ioMode, local, onDelete, toggleEdit }) => (
  <tr>
    <td className="mr-2">
      <FormattedNumber value={item.Quantity} dataTypeDecimalName="quantity" />
    </td>
    <td className="text-center">{item.IsCurrency ? item.CurrencyISO : item.AssetTicker}</td>
    {ioType == IOType.Withdraw && ioMode == IOMode.MultipleAccounts && (
      <td>
        {local
          ? `${item.BankAccountName} ${item.BankAccountNumber}`
          : `${item.BankAccountName} ${item.BankAccountNumber}`}
      </td>
    )}
    <td className="text-right">
      <Button color="btn-outline-primary btn-sm" disabled={readonly} onClick={() => toggleEdit()}>
        <i className="fa fa-pencil" />
      </Button>
      <Button
        color="btn-outline-primary btn-sm"
        disabled={readonly}
        onClick={() => onDelete(item.Id)}
        style={{ color: "#d83737" }}
      >
        <i className="fa fa-trash" />
      </Button>
    </td>
  </tr>
);

export default Assets;
